/**
 * @generated SignedSource<<a8f043d8bc6c9a289f1f5cfde0865bb3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchGraphResult_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly connectorType: string | null;
  readonly id: string;
  readonly integrationId: string | null;
  readonly providerId: string | null;
  readonly subtype: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphBranch_AtlassianSearchPage" | "searchGraphCalendar_AtlassianSearchPage" | "searchGraphCampaign_AtlassianSearchPage" | "searchGraphCase_AtlassianSearchPage" | "searchGraphComment_AtlassianSearchPage" | "searchGraphCommit_AtlassianSearchPage" | "searchGraphConfluenceDc_AtlassianSearchPage" | "searchGraphConversation_AtlassianSearchPage" | "searchGraphCustomerContact_AtlassianSearchPage" | "searchGraphCustomerOrg_AtlassianSearchPage" | "searchGraphDashboard_AtlassianSearchPage" | "searchGraphDataTable_AtlassianSearchPage" | "searchGraphDeal_AtlassianSearchPage" | "searchGraphDefault_AtlassianSearchPage" | "searchGraphDesign_AtlassianSearchPage" | "searchGraphDocument_AtlassianSearchPage" | "searchGraphJiraDc_AtlassianSearchPage" | "searchGraphLead_AtlassianSearchPage" | "searchGraphMessage_AtlassianSearchPage" | "searchGraphProject_AtlassianSearchPage" | "searchGraphPullRequest_AtlassianSearchPage" | "searchGraphRepository_AtlassianSearchPage" | "searchGraphVideo_AtlassianSearchPage" | "searchGraphWorkItem_AtlassianSearchPage">;
  readonly " $fragmentType": "searchGraphResult_AtlassianSearchPage";
};
export type searchGraphResult_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphResult_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphResult_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "includeReactionsAndCommentCount",
  "variableName": "includeReactionsAndCommentCount"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeCaseEmbeddedComments"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeReactionsAndCommentCount"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "includeThirdPartyId"
    }
  ],
  "kind": "Fragment",
  "name": "searchGraphResult_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "providerId"
    },
    {
      "kind": "ScalarField",
      "name": "connectorType"
    },
    {
      "kind": "ScalarField",
      "name": "integrationId"
    },
    {
      "kind": "ScalarField",
      "name": "subtype"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphBranch_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphCalendar_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphComment_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphCommit_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphConfluenceDc_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphConversation_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphCampaign_AtlassianSearchPage"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includeCaseEmbeddedComments",
          "variableName": "includeCaseEmbeddedComments"
        }
      ],
      "kind": "FragmentSpread",
      "name": "searchGraphCase_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphLead_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphCustomerOrg_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphDeal_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphDefault_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphDesign_AtlassianSearchPage"
    },
    {
      "args": [
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "includeThirdPartyId",
          "variableName": "includeThirdPartyId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "searchGraphDocument_AtlassianSearchPage"
    },
    {
      "args": [
        (v0/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "searchGraphComment_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphMessage_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphProject_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphJiraDc_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphPullRequest_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphRepository_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphVideo_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphWorkItem_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphDashboard_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphDataTable_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphCustomerContact_AtlassianSearchPage"
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "aeec444b43f5d6f87e77ec765cb5a2ad";

export default node;
